import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Currency Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const Currency = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'currency.changingCurrencyIsNotSupported':
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="It is not possible to change the currency once it is set!"
                    type="error"
                />
            );
        default:
            return null;
    }
};

Currency.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

Currency.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default Currency;
